
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import Layout from "@/components/layout/Layout";
import ClientesList from "@/components/clientes/ClientesList";
import ClientesSearch from "@/components/clientes/ClientesSearch";
import ClientesHeader from "@/components/clientes/ClientesHeader";
import { useClientes } from "@/hooks/useClientes";

const ClientesPage = () => {
  const {
    filteredClientes,
    geradores,
    search,
    setSearch,
    handleExport,
    userCanAccessCliente,
    userCanAccessGerador,
    isAdmin
  } = useClientes();

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
          <h1 className="text-3xl font-bold text-energy-blue-dark">Clientes</h1>
          <ClientesSearch 
            search={search} 
            onSearchChange={setSearch} 
          />
        </div>

        <Card>
          <CardHeader className="pb-3">
            <ClientesHeader 
              clienteCount={filteredClientes.length}
              isAdmin={isAdmin()}
              onExport={handleExport}
            />
          </CardHeader>
          <CardContent>
            <ClientesList 
              clientes={filteredClientes}
              geradores={geradores}
              userCanAccessCliente={userCanAccessCliente}
              userCanAccessGerador={userCanAccessGerador}
            />
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default ClientesPage;
